export const EmptySpace_MainMessageElementId = 'EmptyState_MainMessage';
